function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
  fill: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7178 4V13.2612H10.8896V6.10742L8.69336 6.80566V5.36475L12.521 4H12.7178Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.3457 6.5C6.3457 6.22386 6.12185 6 5.8457 6C5.56956 6 5.3457 6.22386 5.3457 6.5V8.34666H3.5C3.22386 8.34666 3 8.57052 3 8.84666C3 9.1228 3.22386 9.34666 3.5 9.34666H5.3457V11.1933C5.3457 11.4695 5.56956 11.6933 5.8457 11.6933C6.12185 11.6933 6.3457 11.4695 6.3457 11.1933V9.34666H8.19333C8.46947 9.34666 8.69333 9.1228 8.69333 8.84666C8.69333 8.57052 8.46947 8.34666 8.19333 8.34666H6.3457V6.5Z",
  fill: "white"
});
const SvgPlusOneIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusOneIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus-one-icon.d4a4c39f.svg";
export { ForwardRef as ReactComponent };